import { render, staticRenderFns } from "./qualifications.vue?vue&type=template&id=3c395fb0&scoped=true&"
import script from "./qualifications.vue?vue&type=script&lang=js&"
export * from "./qualifications.vue?vue&type=script&lang=js&"
import style0 from "./qualifications.vue?vue&type=style&index=0&id=3c395fb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c395fb0",
  null
  
)

export default component.exports